import { getYear, isAfter, parseISO, startOfDay } from "date-fns";

/**
 * Global constant for prior-year cancellation cutoff
 * Prior-year consumption cancellations are allowed only until March 31 of the following year
 */
export const PRIOR_YEAR_CUTOFF = { month: 3, day: 31 };

/**
 * Check if a prior-year period is allowed for cancellation based on the global March 31 cutoff.
 * Uses date-only comparison to avoid time-of-day issues (e.g. March 31 at 15:00 > March 31 at 00:00).
 */
export const isPriorYearPeriodAllowed = (
  today: Date,
  periodDate: string
): boolean => {
  const periodYear = getYear(parseISO(periodDate));
  if (Number.isNaN(periodYear)) {
    return false;
  }

  const todayDateOnly = startOfDay(today);

  if (periodYear >= getYear(todayDateOnly)) {
    return true;
  }

  const cutoffDate = new Date(
    periodYear + 1,
    PRIOR_YEAR_CUTOFF.month - 1,
    PRIOR_YEAR_CUTOFF.day
  );
  return !isAfter(todayDateOnly, cutoffDate);
};
